import moment from 'moment';

/**
 * Helpers para el cálculo de días hábiles (excluye fines de semana y feriados).
 * Los feriados se reciben como un Set de strings 'YYYY-MM-DD'.
 */
export default class BusinessDaysUtils {
  static toDateKey(date) {
    return moment(date).format('YYYY-MM-DD');
  }

  static startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  static isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  static isHoliday(date, holidaySet) {
    if (!holidaySet) {
      return false;
    }
    return holidaySet.has(this.toDateKey(date));
  }

  static isBusinessDay(date, holidaySet) {
    return !this.isWeekend(date) && !this.isHoliday(date, holidaySet);
  }

  /**
   * Cuenta los días hábiles posteriores a `start` (exclusivo) hasta `end` (inclusivo).
   * Devuelve 0 si `end` es anterior o igual a `start`.
   */
  static businessDaysBetween(start, end, holidaySet) {
    const from = this.startOfDay(start);
    const to = this.startOfDay(end);
    if (to <= from) {
      return 0;
    }
    let count = 0;
    const cursor = new Date(from);
    cursor.setDate(cursor.getDate() + 1);
    while (cursor <= to) {
      if (this.isBusinessDay(cursor, holidaySet)) {
        count += 1;
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    return count;
  }

  /**
   * Días hábiles faltantes para cumplir el plazo (SLA).
   * = slaDays - (días hábiles transcurridos desde statusDate).
   * Puede ser negativo si el plazo ya venció.
   */
  static remainingBusinessDays(statusDate, slaDays, holidaySet, now = new Date()) {
    const elapsed = this.businessDaysBetween(statusDate, now, holidaySet);
    return slaDays - elapsed;
  }
}
